import { useMemo } from 'react';
import { useData } from './../../../DataContext'; // Import the context

const TranslationFetcher = ({ locale }) => {
    const { clients } = useData(); // Get the context values

    // Compute the translation data based on the locale
    const { translationData, usedLocale } = useMemo(() => {
        const localePassed = locale?.toLowerCase() || 'en'; // Default to 'en' if locale is undefined
        const translations = clients?.commonConfig?.translationData?.translations || {};

        // Get the translation for the passed locale or fallback to 'en'
        const translation = translations[localePassed] || translations['en'];

        const usedLocale = translations[localePassed] ? localePassed : 'en';

        return { translationData: translation, usedLocale }; // Return an object containing both
    }, [locale, clients]); // Recompute when locale or clients change

    return { translationData, localePassed: usedLocale }; // Return an object containing both
};

export default TranslationFetcher;